import { render, staticRenderFns } from "./RefinementTasks.vue?vue&type=template&id=b5c51d2c&scoped=true"
import script from "./RefinementTasks.vue?vue&type=script&lang=js"
export * from "./RefinementTasks.vue?vue&type=script&lang=js"
import style0 from "./RefinementTasks.vue?vue&type=style&index=0&id=b5c51d2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5c51d2c",
  null
  
)

export default component.exports